import { render } from "./BannerColections.vue?vue&type=template&id=e8815866&scoped=true"
import script from "./BannerColections.vue?vue&type=script&lang=js"
export * from "./BannerColections.vue?vue&type=script&lang=js"

import "./BannerColections.vue?vue&type=style&index=0&id=e8815866&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8815866"]])

export default __exports__